import { indexBy, prop } from "ramda";

function dataConnectionCollection(connections) {
    var connectionMap = indexBy(prop('name'), connections);

    // String -> DataConnection
    function get(name) {
        return connectionMap[name];
    }

    // () -> [DataConnection]
    function getAll() {
        return connections;
    }

    // String -> Boolean
    function exists(name) {
        return connectionMap.hasOwnProperty(name);
    }

    // () -> DataConnection
    function getMainQuery() {
        return connections.find(prop('isMainQuery'));
    }

    // interface
    return {
        get,
        getAll,
        exists,
        getMainQuery,
    };
}

export default dataConnectionCollection;